export const BASE_URL =
  process.env.STORYBOOK_ASSETS_DIR || '/us-en/hp-all-in-plan-enroll';

export const PAGE_PDP_CONFIG = `${BASE_URL}/pdp-config`;

export const ROLLOVER_PAGES_MULTIPLIER = 3;

export enum US_STATE_CODES {
  CALIFORNIA = 'CA',
}
